export default __webpack_public_path__ + "static/media/suspense-accounts.5cb17a9f.svg";